(function() {
  var TOTAL_STEPS = 5;
  var currentStep = 1;
  var answers = {};

  var progress = document.getElementById("quiz-progress");
  if (!progress) return;
  for (var i = 1; i <= TOTAL_STEPS; i++) {
    var dot = document.createElement("div");
    dot.className = "quiz-dot" + (i === 1 ? " active" : "");
    dot.dataset.step = i;
    progress.appendChild(dot);
  }

  window.selectOption = function(el) {
    var key = el.dataset.key;
    var value = el.dataset.value;
    answers[key] = value;
    var opts = el.parentElement.querySelectorAll(".quiz-option");
    for (var j = 0; j < opts.length; j++) { opts[j].classList.remove("selected"); }
    el.classList.add("selected");
    setTimeout(function() {
      if (currentStep < TOTAL_STEPS) {
        currentStep++;
        showStep(currentStep);
      } else {
        showResults();
      }
    }, 400);
  };

  window.goBack = function() {
    if (currentStep > 1) {
      currentStep--;
      showStep(currentStep);
    }
  };

  function showStep(step) {
    var steps = document.querySelectorAll(".quiz-step");
    for (var j = 0; j < steps.length; j++) { steps[j].classList.remove("active"); }
    var target = document.querySelector('.quiz-step[data-step="' + step + '"]');
    if (target) target.classList.add("active");
    var dots = document.querySelectorAll(".quiz-dot");
    for (var j = 0; j < dots.length; j++) {
      var dStep = parseInt(dots[j].dataset.step);
      dots[j].className = "quiz-dot";
      if (dStep < step) dots[j].classList.add("done");
      if (dStep === step) dots[j].classList.add("active");
    }
  }

  function showResults() {
    var steps = document.querySelectorAll(".quiz-step");
    for (var j = 0; j < steps.length; j++) { steps[j].classList.remove("active"); }
    var dots = document.querySelectorAll(".quiz-dot");
    for (var j = 0; j < dots.length; j++) { dots[j].classList.add("done"); }
    var result = document.getElementById("quiz-result");
    result.classList.add("active");

    var concern = answers.concern || "hydration";
    var climate = answers.climate || "temperate";

    var routines = {
      acne: {
        headline: "Your Clear Skin Routine",
        summary: "Targeted for breakouts in " + (climate === "tropical" ? "your environment" : "your environment") + ". BHA and tea tree to clear, centella to calm.",
        steps: [
          { step: "Cleanser", desc: "Low-pH foam or gel cleanser to remove excess oil without stripping.", link: "/collections/cleansers", cta: "Shop Cleansers" },
          { step: "Treatment", desc: "BHA serum or tea tree essence to unclog pores and reduce inflammation.", link: "/collections/acne-blemish-care", cta: "Shop Acne Care" },
          { step: "Sunscreen", desc: "Lightweight, non-comedogenic SPF 50+ that will not clog pores.", link: "/collections/suncare", cta: "Shop Suncare" }
        ],
        mainCollection: "/collections/acne-blemish-care"
      },
      brightening: {
        headline: "Your Brightening Routine",
        summary: "Dark spots and uneven tone need consistent actives. Vitamin C, niacinamide, and SPF are your trio.",
        steps: [
          { step: "Cleanser", desc: "Gentle cleanser that will not irritate while you use actives.", link: "/collections/cleansers", cta: "Shop Cleansers" },
          { step: "Treatment", desc: "Vitamin C or niacinamide serum to fade spots and even tone.", link: "/collections/brightening", cta: "Shop Brightening" },
          { step: "Sunscreen", desc: "SPF 50+ PA++++ non-negotiable when using brightening actives.", link: "/collections/suncare", cta: "Shop Suncare" }
        ],
        mainCollection: "/collections/brightening"
      },
      hydration: {
        headline: "Your Hydration Routine",
        summary: "Dehydrated skin needs smart hydration. Lightweight layers that absorb, not sit on top.",
        steps: [
          { step: "Cleanser", desc: "Hydrating cleanser that cleans without stripping moisture.", link: "/collections/cleansers", cta: "Shop Cleansers" },
          { step: "Treatment", desc: "Hyaluronic acid serum or hydrating essence for deep moisture.", link: "/collections/hydration", cta: "Shop Hydration" },
          { step: "Moisturizer + SPF", desc: "Gel-cream moisturizer + lightweight sunscreen.", link: "/collections/moisturizers-creams", cta: "Shop Moisturizers" }
        ],
        mainCollection: "/collections/hydration"
      },
      aging: {
        headline: "Your Anti-Aging Routine",
        summary: "Peptides, retinol, and firming actives that deliver real results.",
        steps: [
          { step: "Cleanser", desc: "Oil or balm cleanser to gently remove SPF without tugging.", link: "/collections/cleansers", cta: "Shop Cleansers" },
          { step: "Treatment", desc: "Retinol or peptide serum to boost collagen and smooth fine lines.", link: "/collections/anti-aging", cta: "Shop Anti-Aging" },
          { step: "Sunscreen", desc: "SPF 50+ sun damage is the #1 cause of aging. Protect what you treat.", link: "/collections/suncare", cta: "Shop Suncare" }
        ],
        mainCollection: "/collections/anti-aging"
      },
      sensitivity: {
        headline: "Your Gentle Skin Routine",
        summary: "Minimal ingredients, maximum calm. Centella and ceramides to rebuild your barrier.",
        steps: [
          { step: "Cleanser", desc: "Fragrance-free, low-pH cleanser that calms while it cleans.", link: "/collections/cleansers", cta: "Shop Cleansers" },
          { step: "Treatment", desc: "Centella or ceramide serum to soothe redness and repair barrier.", link: "/collections/sensitive-skin", cta: "Shop Sensitive Skin" },
          { step: "Sunscreen", desc: "Mineral or hybrid SPF gentle on reactive skin, strong on protection.", link: "/collections/suncare", cta: "Shop Suncare" }
        ],
        mainCollection: "/collections/sensitive-skin"
      }
    };

    var rec = routines[concern] || routines.hydration;
    var climateNote = "";
    if (false) { // climate tips removed
      climateNote = '<p style="margin-top:1em;padding:1em;background:#f0faf0;border-radius:8px;"><strong>Skincare tip:</strong> Wait 60 seconds between serum and sunscreen. Humidity slows absorption.</p>';
    }

    var stepsHtml = "";
    for (var s = 0; s < rec.steps.length; s++) {
      var st = rec.steps[s];
      stepsHtml += '<div style="display:flex;gap:1em;align-items:flex-start;margin-bottom:1.5em;">';
      stepsHtml += '<div style="background:#1a1a2e;color:#fff;border-radius:50%;width:36px;height:36px;display:flex;align-items:center;justify-content:center;flex-shrink:0;font-weight:bold;">' + (s+1) + '</div>';
      stepsHtml += '<div><strong>' + st.step + '</strong><br>' + st.desc + '<br><a href="' + st.link + '" style="color:#1a1a2e;font-weight:600;">' + st.cta + ' \u2192</a></div></div>';
    }

    result.innerHTML = '<h3>' + rec.headline + '</h3><p style="color:#666;margin-bottom:2em;">' + rec.summary + '</p>' + stepsHtml + climateNote + '<div style="text-align:center;margin-top:2em;"><a href="' + rec.mainCollection + '" class="quiz-cta">Shop My Routine \u2192</a></div>';
  }

  var emailForm = document.getElementById("quiz-email-form");
  if (emailForm) {
    emailForm.addEventListener("submit", function(e) {
      e.preventDefault();
      var email = document.getElementById("quiz-email").value;
      if (email) {
        var skipLink = document.querySelector(".quiz-skip");
        if (skipLink) skipLink.click();
      }
    });
  }

  var skipLink = document.querySelector(".quiz-skip");
  if (skipLink) {
    skipLink.addEventListener("click", function(e) {
      e.preventDefault();
      showResults();
    });
  }
})();